"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var helpers_1 = require("../../../utils/helpers");
var Panel_1 = require("../../Panel");
var PanelFooter_1 = require("../../PanelFooter");
var PanelBody_1 = require("../../PanelBody");
var PanelRow_1 = require("../../PanelRow");
var Button_1 = require("../../Button");
var Select_1 = require("../../Select");
var Field_1 = require("../../Field");
var modes = [
    {
        label: 'Year',
        value: 'year',
    },
    {
        label: 'Date Range',
        value: 'range',
    },
];
var yearsInputRegex = new RegExp(/^[0-9,]*$/);
var propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    noDateLabel: PropTypes.string,
    className: PropTypes.string,
    mods: PropTypes.string,
    style: PropTypes.object,
    yearPlaceholder: PropTypes.string,
    rangeMin: PropTypes.string,
    rangeMax: PropTypes.string,
};
var formatDate = function (x) {
    if (!x)
        return undefined;
    var date = new Date(x);
    date = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    date.setHours(0);
    return date;
};
var formatDisplayDate = function (date, locales) {
    if (locales) {
        return new Intl.DateTimeFormat(locales).format(formatDate(date));
    }
    return new Intl.DateTimeFormat(navigator.languages ? __spreadArray([], navigator.languages, true) : navigator.language).format(formatDate(date));
};
var DateFilter = function (_a) {
    var name = _a.name, title = _a.title, onChange = _a.onChange, disabled = _a.disabled, className = _a.className, mods = _a.mods, noDateLabel = _a.noDateLabel, yearPlaceholder = _a.yearPlaceholder, rangeMin = _a.rangeMin, rangeMax = _a.rangeMax, props = __rest(_a, ["name", "title", "onChange", "disabled", "className", "mods", "noDateLabel", "yearPlaceholder", "rangeMin", "rangeMax"]);
    var _b = React.useState('year'), mode = _b[0], setMode = _b[1];
    var _c = React.useState(false), hasFilters = _c[0], setHasFilters = _c[1];
    var _d = React.useState(false), flyoutVisible = _d[0], toggleFlyout = _d[1];
    var _e = React.useState(''), years = _e[0], setYears = _e[1];
    var _f = React.useState(''), fromDate = _f[0], setFromDate = _f[1];
    var _g = React.useState(''), toDate = _g[0], setToDate = _g[1];
    var _h = React.useState(title), buttonLabel = _h[0], setButtonLabel = _h[1];
    var clearFilters = function () {
        toggleFlyout(false);
        setYears('');
        setFromDate('');
        setToDate('');
        setHasFilters(false);
        onChange();
        setButtonLabel(title);
        if (mode === 'noDate') {
            setMode('year');
            toggleFlyout(false);
        }
    };
    var applyFilters = function () {
        if ((mode === 'year' && !years) || (mode === 'range' && !fromDate && !toDate)) {
            setYears('');
            setFromDate('');
            setToDate('');
            return;
        }
        if (mode === 'noDate') {
            setYears('');
            setFromDate('');
            setToDate('');
            setHasFilters(true);
            setButtonLabel("".concat(noDateLabel || '[No Date]'));
            onChange({ kind: 'noDate' });
            return;
        }
        if (mode === 'range') {
            setYears('');
            if (fromDate && !toDate) {
                setButtonLabel("After ".concat(formatDisplayDate(fromDate)));
            }
            else if (toDate && !fromDate) {
                setButtonLabel("Before ".concat(formatDisplayDate(toDate)));
            }
            else {
                setButtonLabel([formatDisplayDate(fromDate), formatDisplayDate(toDate)].filter(function (x) { return !!x; }).join(' - '));
            }
            setHasFilters(true);
            onChange({
                kind: 'range',
                value: { from: formatDate(fromDate), to: formatDate(toDate) },
            });
            return;
        }
        if (years.length > 0) {
            var elements = years.split(',').filter(function (item) { return !!item; });
            var cleanYears = elements.join(',');
            setButtonLabel(cleanYears);
            setFromDate('');
            setToDate('');
            setHasFilters(true);
            onChange({ kind: 'years', value: elements });
            setYears(cleanYears);
        }
    };
    var onChangeYear = function (e) {
        var value = e.target.value;
        if (yearsInputRegex.test(value)) {
            if (!years && value === ',') {
                return;
            }
            if (value[value.length - 1] === ',' && years[years.length - 1] === ',') {
                return;
            }
            setYears(value);
        }
    };
    // Set up handler when flyoutVisibility changes
    React.useEffect(function () {
        var handleBodyClick = function (e) {
            var isTargetingPopup = e.target.closest("#Combobox-".concat(name)) != null;
            if (!isTargetingPopup) {
                toggleFlyout(false);
            }
        };
        document.body.addEventListener('click', handleBodyClick, { capture: true });
        return function () {
            document.body.removeEventListener('click', handleBodyClick);
        };
    }, []);
    React.useEffect(function () {
        if (!flyoutVisible) {
            applyFilters();
        }
    }, [flyoutVisible]);
    return (React.createElement("div", __assign({ id: "Combobox-".concat(name), className: (0, helpers_1.getClassName)(className, mods) }, props),
        React.createElement("button", { "data-testid": "toggle-flyout-button", type: "button", className: "Combobox-toggle ".concat(hasFilters ? 'Combobox-toggle--active' : ''), name: name, id: name, disabled: disabled, title: buttonLabel, onClick: function () {
                toggleFlyout(!flyoutVisible);
            } }, buttonLabel),
        flyoutVisible && (React.createElement(Panel_1.Panel, { testId: "flyout", mods: "Combobox-checkboxContainer" },
            React.createElement(PanelBody_1.PanelBody, null,
                React.createElement(PanelRow_1.PanelRow, { mods: "Grid-cell u-flexAuto u-padBottomMd" },
                    React.createElement(Select_1.Select, { name: "mode", mods: mode === 'noDate' ? '' : 'u-spaceBottomMd', options: __spreadArray(__spreadArray([], modes, true), [{ value: 'noDate', label: "".concat(noDateLabel || '[No Date]') }], false), inputProps: {
                            value: mode,
                            onChange: function (e) {
                                setMode(e.target.value);
                            },
                        } }),
                    mode === 'year' && (React.createElement(Field_1.Field, { type: "input", name: "years", caption: "Use commas to separate multiple years.", formFieldProps: {
                            inputProps: {
                                placeholder: yearPlaceholder,
                                value: years,
                                onChange: onChangeYear,
                            },
                        } })),
                    mode === 'range' && (React.createElement(React.Fragment, null,
                        React.createElement(Field_1.Field, { mods: "u-spaceBottomMd", label: "From:", type: "date", name: "fromDate", formFieldProps: {
                                inputProps: {
                                    min: rangeMin,
                                    max: rangeMax,
                                    value: fromDate,
                                    onChange: function (e) { return setFromDate(e.target.value); },
                                },
                            } }),
                        React.createElement(Field_1.Field, { label: "To:", type: "date", name: "toDate", formFieldProps: {
                                inputProps: {
                                    min: rangeMin,
                                    max: rangeMax,
                                    value: toDate,
                                    onChange: function (e) { return setToDate(e.target.value); },
                                },
                            } }))))),
            React.createElement(PanelFooter_1.PanelFooter, { mods: "u-padEndsSm u-padSidesMd" },
                React.createElement(Button_1.Button, { onClick: function () {
                        clearFilters();
                    }, mods: "u-spaceRightMd u-colorNeutral7", type: "link" }, "Clear"),
                React.createElement(Button_1.Button, { onClick: function () { return toggleFlyout(false); }, type: "link" }, "Done"))))));
};
DateFilter.propTypes = propTypes;
DateFilter.defaultProps = {
    mods: null,
    style: {},
    className: 'Combobox',
    noDateLabel: 'No Date',
    yearPlaceholder: null,
    rangeMin: null,
    rangeMax: null,
};
exports.default = DateFilter;
